// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"_2DTZ6x9UaPiQbXgES8IoUL"};